module.exports = __webpack_public_path__ + "img/1471742168.e250b23f.jpg";